import React from 'react';
import { Button } from '@/ui/components/atoms/Button';
import { 
  ArrowLeftIcon, 
  ArrowRightIcon, 
  CalendarIcon 
} from '@heroicons/react/24/outline';
import { WeekNavigationProps } from '../../types/planning.types';
import { getWeekRangeText } from '../../utils/dateFormatters';
import './WeekNavigation.styles.css';

export const WeekNavigation: React.FC<WeekNavigationProps> = ({
  currentWeek,
  onWeekChange
}) => {
  const weekRangeText = getWeekRangeText(currentWeek);

  return (
    <div className="week-navigation">
      <Button
        variant="secondary"
        size="medium"
        icon={<ArrowLeftIcon className="w-5 h-5" />}
        onClick={() => onWeekChange(currentWeek - 1)}
        className="week-navigation__button"
      >
        Semaine précédente
      </Button>

      <span className="week-navigation__label">
        {weekRangeText}
      </span>

      <Button
        variant="secondary"
        size="medium"
        icon={<ArrowRightIcon className="w-5 h-5" />}
        onClick={() => onWeekChange(currentWeek + 1)}
        className="week-navigation__button"
      >
        Semaine suivante
      </Button>

      <Button
        variant={currentWeek === 0 ? "secondary" : "primary"}
        size="medium"
        icon={<CalendarIcon className="w-5 h-5" />}
        onClick={() => onWeekChange(0)}
        disabled={currentWeek === 0}
        className="week-navigation__button week-navigation__button--today"
      >
        Aujourd'hui
      </Button>
    </div>
  );
};